import {request} from '@/utils/request'
// import requestTest from '@/utils/request'

// 获取短信验证码
export const getMessageCode = data => {
  return request({
    method: 'POST',
    url: '/api/user/register/sendSMS',
    data
  })
}

// 用户登录
export const login = data => {
  return request({
    method: 'POST',
    url: '/api/user/login/login',
    data
  })
}

// 用户注册
export const register = data => {
  return request({
    method: 'POST',
    url: '/api/user/register/register',
    data
  })
}

// 检查手机号和验证码
export const CheckPhone = data => {
  return request({
    method: 'POST',
    url: '/api/user/findpwd/checkPhoneAndVerifyCode',
    data
  })
}

// 获取数字认证码
export const getVerifyCode = () => {
  return request({
    method: 'GET',
    url: '/api/user/register/getguidCode'
  })
}

// 获取省市区
export const getRegionalData = data => {
  return requestTest({
    method: 'POST',
    url: '/api/user/area/getCity',
    data
  })
}
